import React from 'react';
import PropTypes from 'prop-types';
import Card from './Card';
import styles from './KudosCard.module.scss';
import DefaultAvatar from '../../../assets/icons/svgIcons/avatar.svg';
import { Coin } from '../../../assets/icons/iconComponents2';
import ArrowBackIosRoundedIcon from '@material-ui/icons/ArrowBackIosRounded';
import { parseDate } from '../../../helpers/date';
import Avatar from '@material-ui/core/Avatar';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Like from '../Like';
import { generatePath, useHistory } from 'react-router-dom';
import { routes } from '../../../assets/routes';
import RtlWrapper from '../../../helpers/RtlWrapper';
import { modules } from '../../../helpers/modules';

const KudosCard = (props) => {
  const history = useHistory();

  return (
    <Card
      {...props}
      onClick={() => {
        history.push(generatePath(routes.KUDOS, { id: props.data.id }));
      }}
    >
      <div className={styles.wrapper}>
        <div className={styles.body}>
          <div className={styles.info}>
            <div className={styles.pics}>
              <Avatar
                alt={props.data.sender.first_name}
                src={props.data.sender.avatar?.thumbnail || DefaultAvatar}
                className={styles.small}
              />
              <ArrowBackIosRoundedIcon className="flip-ltr" />
              {modules.group_reco && !!props.data.receivers.length ? (
                <RtlWrapper>
                  <AvatarGroup max={3} classes={{ avatar: styles.small }}>
                    {props.data.receivers.map((receiver, index) => (
                      <Avatar
                        key={index}
                        alt={receiver.first_name}
                        src={receiver.avatar?.thumbnail || DefaultAvatar}
                        className={styles.small}
                      />
                    ))}
                  </AvatarGroup>
                </RtlWrapper>
              ) : (
                <Avatar
                  alt={props.data.receiver.first_name}
                  src={props.data.receiver.avatar?.thumbnail || DefaultAvatar}
                  className={styles.small}
                />
              )}
            </div>
            <div className={styles.time}>
              {parseDate(props.data.created_at)}
            </div>
            <div className={styles.note} dir="auto">
              {props.data.note}
            </div>
          </div>
          <div className={styles.kudos}>
            <img
              src={props.data.card.photo?.thumbnail || DefaultAvatar}
              alt="kudos card"
            />
            {!!props.data.coin && (
              <div className={styles.coins}>
                <Coin />
                <span>{props.data.coin}</span>
              </div>
            )}
          </div>
        </div>
        <Like
          likesCount={props.data.likes_count}
          isFetching={props.isFetching}
          likedByMe={props.data.liked_by_me}
          commentsCount={props.data.comments_count}
          id={props.data.id}
          isSysAdmin={props.isSysAdmin}
          isOrgAdmin={props.isOrgAdmin}
          isRemoveKudosActive={props.isRemoveKudosActive}
        />
      </div>
    </Card>
  );
};

KudosCard.propTypes = {
  id: PropTypes.string,
  isFetching: PropTypes.bool,
  extraClass: PropTypes.string,
  extraStyle: PropTypes.object,
  data: PropTypes.shape({
    coin: PropTypes.number,
    likes_count: PropTypes.number,
    comments_count: PropTypes.number,
    liked_by_me: PropTypes.bool,
    sender: PropTypes.shape({
      id: PropTypes.number,
      img: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      avatar: PropTypes.shape({
        thumbnail: PropTypes.string
      })
    }),
    receiver: PropTypes.shape({
      id: PropTypes.number,
      img: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      avatar: PropTypes.shape({
        thumbnail: PropTypes.string
      })
    }),
    receivers: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        img: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string
      })
    ),
    id: PropTypes.number,
    note: PropTypes.string,
    created_at: PropTypes.string,
    card: PropTypes.shape({
      id: PropTypes.number,
      title: PropTypes.string,
      is_active: PropTypes.bool,
      photo: PropTypes.shape({
        thumbnail: PropTypes.string
      })
    })
  }),
  isOrgAdmin: PropTypes.bool,
  isSysAdmin: PropTypes.bool,
  isRemoveKudosActive: PropTypes.bool
};

export default KudosCard;
